import { render, staticRenderFns } from "./TripartiteIndex.vue?vue&type=template&id=40a876ac&scoped=true&"
import script from "./TripartiteIndex.vue?vue&type=script&lang=js&"
export * from "./TripartiteIndex.vue?vue&type=script&lang=js&"
import style0 from "./TripartiteIndex.vue?vue&type=style&index=0&id=40a876ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a876ac",
  null
  
)

export default component.exports